<template>
<v-list-tile v-if='client.id'
  @click.native='$emit("listitem:clicked", client)' :key="client.id">
  <!-- <slot name='avatar' >
  <v-list-tile-avatar>
    <v-avatar >{{ initials(client) }}</v-avatar>
  </v-list-tile-avatar>
  </slot> -->
  <slot name='avatar' >
  <v-list-tile-avatar v-if='withGravatar && client.email' >
    <v-avatar>
      <img :src='getGravatar(client.email)' />
    </v-avatar>
  </v-list-tile-avatar>
  </slot>
  <v-list-tile-action v-if='withEdit && relationshipId' >
    <v-btn small
      @click.stop="launchCustomerDetailsDialog(relationshipId, true)" icon small >
      <v-icon >edit</v-icon>
    </v-btn>
  </v-list-tile-action>
  <v-list-tile-content>
    <v-list-tile-title >
      <slot name='after-before'></slot>
      <v-hover
        v-slot:default="{ hover }" >
        <strong>
          {{fullName}}
          <small class='grey--text' v-if='hover' >
            <span v-if='client.custom_id' >
              / #{{client.custom_id}}
            </span>
            <span v-if='client.phone_number' >
              / {{client.phone_number}}
            </span>
            <span span v-if='isRealEmail(client.email)' >
              / {{client.email}}
            </span>
            <span v-if='relationshipId' >
              / # {{relationshipId}}
            </span>
          </small>
        </strong>
      </v-hover>
      <slot name='after-title'></slot>
    </v-list-tile-title>
    <slot name='subtitle' >
    <v-list-tile-sub-title v-if='withDetails' >
      <span @click.native='$emit("phoneClicked", client.phone_number)' v-if='client.phone_number' small>
        <v-icon class='hidden-xs-only' small>phone</v-icon>
        {{client.phone_number}}
      </span>
      <span v-if='isRealEmail(client.email)'
        @click.native='$emit("emailClicked", client.email)'
        small> <v-icon class='hidden-xs-only' small>mail</v-icon> {{client.email}}</span>
    </v-list-tile-sub-title>
    </slot>
    <slot name='extrasubtitle' ></slot>
  </v-list-tile-content>

  <slot name="actions" >
  </slot>

  <space-faces
    tooltip-prefix='Shared with '
    :space-ids='spaces'
    :size='16' >
  </space-faces>

  <v-divider v-if='owner' vertical class='mx-2' />

  <practitioner-faces
    v-if='owner'
    tooltip-prefix='Owned by '
    :practitioner-ids='[owner]'
    :size='16' >
  </practitioner-faces>

  <template v-if="withWhatsApp" >
    <v-divider vertical class='ml-3' />
    <whats-app-btn small
      v-if="client.phone_number"
      :number='client.phone_number' classes="mr-0" />
    <v-btn v-else disabled flat icon small class="mr-0" >
      <v-icon small >whatsapp</v-icon>
    </v-btn>
  </template>
    <!-- <v-chip x-small color='success' class='v-chip--x-small' outline outlined >shared</v-chip> -->

  <v-list-tile-action v-if='withAction' >
    <slot name='action' >
    <v-btn @click='$emit("listitem:goclicked", client)' icon >
      <v-icon class="grey--text text--lighten-1">chevron_right</v-icon>
    </v-btn>
    </slot>
  </v-list-tile-action>

</v-list-tile>
</template>
<script type="text/javascript">
import SpaceFaces from '@/components/lists/SpaceFaces'
import PractitionerFaces from '@/components/lists/PractitionerFaces'
import WhatsAppBtn from '@/components/ui/WhatsAppBtn.vue'

export default {
  name: 'ClientListItem',
  components: {SpaceFaces, PractitionerFaces, WhatsAppBtn},
  props: {
    client: { type: Object, default: () => { return {} } },
    spaces: { type: Array, required: false },
    relationshipId: { type: Number, required: true },
    owner: { required: false },
    withEdit: { type: Boolean, default: false },
    withDetails: { type: Boolean, default: true },
    withAction: { type: Boolean, default: true },
    withDivider: { type: Boolean, default: true },
    withGravatar: { type: Boolean, default: false },
    withWhatsApp: { type: Boolean, default: false },
    showSpaces: { type: Boolean, default: false }
  },
  computed: {
    avatar () {
      if (this.client && this.client.profile && this.client.profile_picture) {
        return this.client.profile_picture
      }
      return this.client.first_name.substr(0, 1)
    },
    fullName () {
      return this.formatFullName(this.client)
    }
  }
}
</script>
<style >
.list__tile .chip .avatar,
.chip .list__tile__action {
  min-width: 30px;
}
.chip .icon {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// ClientListItem.vue?6d1a5e0b